// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:e6xVYQ */\n.iUYhA{align-items:center;display:flex;gap:var(--audio-spacing-16)}.XofZw{align-items:center;display:flex;gap:var(--audio-spacing-4)}.L1sE0{color:var(--audio-content-primary)}.a2qWy{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"follow": "iUYhA",
	"followers": "XofZw",
	"icon": "L1sE0",
	"count": "a2qWy"
};
export default ___CSS_LOADER_EXPORT___;
